import React, {Component} from 'react';
import {SortableElement} from 'react-sortable-hoc';
import PropTypes from "prop-types";

class SortableSubjectsItem extends Component {
    render(){
            return (
                <div className="sortable-subject">{this.props.number + 1}. {this.props.fs.name} - (id: {this.props.subject})</div>
            )

    }
}

export default SortableElement(SortableSubjectsItem);


// WEBPACK FOOTER //
// ./src/components/AdminPanel/Strategy/SortableSubjectsItem.js